import {recruitRes} from '@/api'
export default {
    state: {
        recruitList: [
        ],
        postList:[]
    },
    getters: {
        getRecruitList(state) {
            return state.recruitList
        },
        getPostList(state) {
            return state.postList
        }
    },
    actions: {
        loadRecruitList({commit,state},data= {}){
           return new Promise((resolve,reject) => {
            recruitRes.getListForQuery(data).then(res => {
                res.map(item => {
                    item.name = item.title;
                    item.value = item.id;
                  });
                commit('SET_RECRUIT_LIST',res)
                resolve(res)
            })
           })
        },
        loadPostList({commit,state},data= {}){
            return new Promise((resolve,reject) => {
             recruitRes.getPostList(data).then(res => {
                 res.map(item => {
                     item.value = item.id;
                   });
                 commit('SET_POST_LIST',res)
                 resolve(res)
             })
            })
         }
    },
    mutations: {
        SET_RECRUIT_LIST(state,data){
            state.recruitList = data
        },
        SET_POST_LIST(state,data){
            state.postList = data

        }
    }
}
